import { render, staticRenderFns } from "./BookingListItem.vue?vue&type=template&id=5b3d59b2"
import script from "./BookingListItem.vue?vue&type=script&lang=js"
export * from "./BookingListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports